import React from 'react';
import { Helmet } from 'react-helmet-async';

/**
 * SEO Component for dynamic meta tags
 * Usage: <SEO title="Page Title" description="Page description" />
 */
function SEO({ 
  title = 'Acne Safe | Ingredient Scanner',
  description = 'Scan skincare ingredients to check if products are safe for acne-prone skin. Instant ingredient analysis powered by AI. Check for comedogenic ingredients before you buy.',
  keywords = 'acne safe, skincare ingredients, comedogenic ingredients, pore clogging, ingredient scanner, acne prone skin, skincare analysis',
  image = '/hero-image.png',
  url = 'https://www.useacnesafe.com/',
  type = 'website'
}) {
  const fullTitle = title.includes('Acne Safe') ? title : `${title} | Acne Safe`;
  const fullImageUrl = image.startsWith('http') ? image : `https://www.useacnesafe.com${image}`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="title" content={fullTitle} />
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={url} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={fullImageUrl} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="630" />
      <meta property="og:site_name" content="Acne Safe" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={fullImageUrl} />
    </Helmet>
  );
}

export default SEO;

